import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

// Editable + searchable dropdown: type free text OR pick a suggestion.
export default function FreeTextSelect({ value, onChange, options = [], placeholder = "ఎంచుకోండి లేదా టైప్ చేయండి", testid = "fts" }) {
  const [open, setOpen] = useState(false);
  const [filtering, setFiltering] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setFiltering(false); } };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const filtered = filtering && value
    ? options.filter((o) => o.toLowerCase().includes(String(value).toLowerCase()))
    : options;

  return (
    <div ref={ref} className="relative">
      <input
        data-testid={testid}
        value={value || ""}
        onChange={(e) => { onChange(e.target.value); setOpen(true); setFiltering(true); }}
        onFocus={() => { setOpen(true); setFiltering(false); }}
        placeholder={placeholder}
        autoComplete="off"
        className="flex h-10 w-full rounded-md border border-goldline/50 bg-white px-3 py-2 pr-8 text-sm font-telugu outline-none focus:ring-2 focus:ring-saffron/40"
      />
      <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-saffron pointer-events-none" />
      {open && filtered.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto rounded-md border border-goldline/50 bg-surface temple-shadow">
          {filtered.map((o) => (
            <button key={o} type="button" data-testid={`${testid}-opt`}
              onMouseDown={(e) => { e.preventDefault(); onChange(o); setOpen(false); setFiltering(false); }}
              className={`block w-full text-left px-3 py-2 text-sm font-telugu hover:bg-marigold/15 ${o === value ? "bg-marigold/20 text-saffron font-semibold" : "text-maroon"}`}>
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
